import { render, staticRenderFns } from "./commonConfigView.vue?vue&type=template&id=2999608c&"
import script from "./commonConfigView.vue?vue&type=script&lang=js&"
export * from "./commonConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports